import * as types from './mutation-types'

export default {
  [types.LOAD_METHODS](state, data) {
    state.methods = data.data
  },
}
